<template>
    <b-col class="text-center" cols="4" xl="2" style="margin-bottom:30px;min-height: 320px;" v-on:click="selectEntry" @mouseover="mouseOver" @mouseleave="mouseLeave">
      <b-row  id="componentNameRow" v-show="ComponentNameHide">
        <b-col>
        {{ComponentName}}
        </b-col>
      </b-row>
      <b-card-group>
        <b-card-img  v-if="onLanding !== true && index % 2 === 0" style="border-radius: 10px; padding-bottom:10px;background-color: #ffcc00"
                     height="200"
                     width=20
                     id="cardImage"
                     :src="Thumbnail" img-alt="Image" fluid class="shadow" v-bind:class="{hovering : isActive}">
        </b-card-img>
        <b-card-img  v-if="onLanding !== true && index % 2 === 1" style="border-radius: 10px; padding-bottom:10px;background-color: #660032"
                     height="200"
                     width=20
                     id="cardImage"
                     :src="Thumbnail" img-alt="Image" fluid class="shadow" v-bind:class="{hovering : isActive}">
        </b-card-img>
        <!--Used due to if this was not done the height would be massively skewed-->
        <b-card-img  v-if="onLanding === true" style="border-radius: 10px; padding-bottom:10px; background-color: #660032;"
                     :src="Thumbnail" img-alt="Image" fluid class="shadow" v-bind:class="{hovering : isActive}">
        </b-card-img>
        
      </b-card-group>
      <span style="color: #000000;">{{TitleWithPages}}</span>
    </b-col>
</template>
<script>
export default {
  name: "browse-entry",
  props: ['ID', 'Title', 'Thumbnail', 'FileURL', 'ContentType', 'ComponentName', 'IsAssignment', 'BaseContent', 'StartPoint', 'EndPoint','onLanding','index'],
  data : function() {
    return {
      isActive: false,
      TitleWithPages: "",
      ComponentNameHide:false
    }
  },
  mounted: function() {
    this.TitleWithPages = this.Title;
    
    if(this.StartPoint !== undefined && this.EndPoint !== undefined) {
      this.TitleWithPages = this.Title + " [" + (parseInt(this.StartPoint)+1) + "-" + (parseInt(this.EndPoint)+1) + "]";
    }
  },
  methods: {
    selectEntry: function() {
      switch(this.ContentType)
      {
        case 'BOOK':
          if(this.IsAssignment) {
            window.location.href = "/BookViewer/web/viewer.html?file=" + btoa(this.BaseContent).replace('/', '_').replace('+', '-') + "&Assignment=" + this.FileURL;
          } else {
            window.location.href = "/BookViewer/web/viewer.html?file=" + btoa(this.FileURL).replace('/', '_').replace('+', '-');
          }
          break;

        case "VIDEO":
          if(this.IsAssignment) {
          this.$router.push({ path: "/video/" + btoa(this.BaseContent).replace('/', '_').replace('+', '-') + "?Assignment=" + this.FileURL });
          } else {
          this.$router.push({ path: "/video/" + btoa(this.FileURL).replace('/', '_').replace('+', '-') });
          }
          break;

        case "AUDIO":
          if(this.IsAssignment) {
            this.$router.push({ path: "/interactive/" + this.ComponentName + "/" + this.FileURL + "?Assignment"});
          } else {
            this.$router.push({ path: "/interactive/" + this.ComponentName + "/" + this.ID});
          }
          break;

        case "INTERACTIVE":
          if(this.IsAssignment) {
            if(this.ComponentName == "pdf")
            {
              window.location.href = "/BookViewer/web/viewer.html?file=" + btoa(this.BaseContent).replace('/', '_').replace('+', '-') + "&Assignment=" + this.FileURL;
            }
            else {
              this.$router.push({ path: "/interactive/" + this.ComponentName + "/" + this.FileURL + "?Assignment"});
            }
          } else {
            if(this.ComponentName == "pdf"){
              window.location.href = "/BookViewer/web/viewer.html?file=" + btoa(this.FileURL).replace('/', '_').replace('+', '-');
            }
            else {
              this.$router.push({path: "/interactive/" + this.ComponentName + "/" + this.ID});
            }
          }
           //works on assignments, not interactive
          break;

         case "FEATURED":
           if(this.IsAssignment) {
             this.$router.push({ path: "/featured/" + this.ComponentName + "/" + this.FileURL + "?Assignment"});
           } else {
             this.$router.push({ path: "/featured/" + this.ComponentName + "/" + this.ID});
           }
           break;
        default: break;
      }
      
    },
    mouseOver : function() {
      this.isActive = true;
      this.ComponentNameHide = true;
      this.ComponentName = String(this.ComponentName).toUpperCase();
    },
    mouseLeave : function() {
      this.isActive = false;
      this.ComponentNameHide = false;
    }
  }
};
</script>
<style scoped>
.hovering {
    box-shadow: 20px 20px 40px 0px rgba(0,0,0,0.5) !important;
  }

</style>